
<template>
  <div class="common-layout" style="margin-top: 50px">
    <el-container>
      <!--          <el-input style="width: 15%" v-model="session" placeholder="请输入createBy"/>&nbsp;&nbsp;&nbsp;&nbsp;-->
      <!--          <el-button>设置session</el-button>-->
      <el-aside   width="450px" style="margin-top: -70px">
        <el-button type="primary" size="small" style="margin-left: -70px" @click="append2">添加省份</el-button>
        <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText"
            clearable>
        </el-input>
        <el-tree :data="treeData"
                 :props="defaultProps"
                 node-key="areaLevel"
                 ref="tree"
                 highlight-current
                 :default-expanded-keys="[3]"
                 :expand-on-click-node="false"
                 auto-expand-parent
                 @node-click="handleNodeClick"
                 style="margin-top: 5px"
                 :filter-node-method="filterNode"
                 >

          <template #default="{ node, data }" >
                        <span class="custom-tree-node" >
                          <span>{{ node.data.areaName }}</span>
                          <span style="margin-left: 5px">

                            <el-button  class="iconfont icon-tianjia" size="small" style="margin-left: 1px; "
                                        v-show="node.data.areaLevel !== 3"
                                        @click="append(data)" type="primary">
                            </el-button>
                            <el-button class="iconfont icon-xiugai1" size="small" v-show="node.data.parentId !== -2"
                                       style="margin-left: 1px" @click="handleEdit(data,0,node)" type="primary">
                            </el-button>
                             <el-popconfirm title="确定删除此区域？" width="150"  @confirm="remove(node, data)">
                                    <template #reference>
<!--                                         <a v-show="node.data.struct_parentid !== -2" class="iconfont icon-changyonggoupiaorenshanchu"   style="margin-left: 8px; background-color: red" ></a>-->
                                        <el-button  class="iconfont icon-changyonggoupiaorenshanchu" size="small" v-show="node.data.parentId !== -2"
                                                    style="margin-left: 1px"  type="danger">
                                        </el-button>
                                    </template>
                             </el-popconfirm>

                          </span>
                        </span>
          </template>
        </el-tree>

      </el-aside>
      <el-main v-show="show"  style="height: 700px;margin-top: -80px"  >
<!--        <el-input />-->
<!--        <div style="margin-left: -200px">-->
<!--          <el-input style="width: 30%" v-model="shuru" placeholder="请输入用户名" clearable/>-->
<!--        </div>-->
        <el-header style="height: 100px">
          <div style="margin-top: 20px">
          <el-table
              :data="tableData"
              style="width: auto"
              border
              :row-class-name="tableRowClassName"
          >
            <el-table-column label="操作" style="width: auto" min-width="25%">
              <template #default="scope">
                <el-button type="primary" size="small" :disabled="scope.row.areaLevel !== 3"   @click="handleEdit( scope.row)">修改</el-button>
                <el-popconfirm title="确定删除此区域?" width="150" @confirm="shanchu(scope.row)">
                  <template #reference>
                    <el-button size="small" style="margin-left: 3px;" :disabled="scope.row.areaLevel !== 3"  type="danger">删除</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
            <el-table-column prop="areaName" style="width: auto" min-width="75%"  label="区域名称"></el-table-column>
            <!--                        <el-table-column prop="account_Lock" width="150" label="状态"></el-table-column>-->
          </el-table>
          </div>
          <el-pagination v-model:currentPage="currentPage"
                         v-model:page-size="pageSize"
                         :page-sizes="[5, 10, 20]"
                         :small="small"
                         :background="background"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"
                         :prev="prev"
                         :pager="pager"
                         :next="next"
                         :jumper="jumper"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"/>

        </el-header>
        <el-footer>
          <div class="demonstration" style="margin: 10px 0">
          </div>
        </el-footer>
      </el-main>
    </el-container>
    <el-dialog v-model="dialogFormVisible" title="添加关联区域 " :lock-scroll="false" width="40%" draggable>
      <el-form :model="form" ref="form" :rules="rules"  status-icon   label-width="140px">
        <el-form-item label="区域名称" prop="areaName"  >
          <el-input v-model="form.areaName" placeholder="请输入区域名称" clearable   autocomplete="off"  required></el-input>
        </el-form-item>
        <el-input type="hidden" v-model="form.parentId"></el-input>
        <el-input type="hidden" v-model="form.areaLevel"></el-input>
        <el-input type="hidden" v-model="form.createBy"></el-input>
      </el-form>
      <template #footer>
                      <span class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">关闭</el-button>
                        <el-button type="primary" @click="save('form')">确定</el-button>
                      </span>
      </template>
    </el-dialog>
    <el-dialog v-model="dialogFormVisibleEdit" :lock-scroll="false" title="编辑关联区域 " width="40%" draggable>
      <el-form :model="editform" ref="editform" :rules="rules" status-icon   label-width="140px">
        <el-form-item label="区域名称" prop="struct_name"  >
          <el-input v-model="editform.areaName" placeholder="请输入区域名称" clearable   autocomplete="off"  required></el-input>
        </el-form-item>
        <el-input type="hidden" v-model="editform.parentId"></el-input>
        <el-input type="hidden" v-model="editform.areaLevel"></el-input>
        <el-input v-model="editform.createBy" type="hidden"/>
        <el-input v-model="editform.createDate" type="hidden"/>
        <el-input v-model="editform.updateBy" type="hidden"/>
        <!--                <el-form-item label="组织类型">-->
        <!--                    <el-select v-model="editform.struct_type" placeholder="请选择组织类型">-->
        <!--                        <el-option v-for="item in options" :key="item.dept_ID" :label="item.dept_Name"-->
        <!--                                   :value="item.dept_Type">-->
        <!--                        </el-option>-->
        <!--                    </el-select>-->
        <!--                </el-form-item>-->
      </el-form>

      <template #footer>
                      <span class="dialog-footer">
                        <el-button @click="dialogFormVisibleEdit = false">关闭</el-button>
                        <el-button type="primary" @click="edit('editform')">确定</el-button>
                      </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
    import request from "../../util/request";

    export default {
        name: "StructSetIndex",

    data() {
        let validateStruct_Name = (rule, value, callback) => {

                if(value === this.repeatName && this.dialogFormVisibleEdit===true ){
                    callback();
                }else {
                    if ( this.dialogFormVisibleEdit===false ){
                        this.getStructByName(rule, value, callback);
                    }else if ( this.judge === 1 ){
                        this.getStructByName(rule, value, callback);
                    }else{
                        request.get('/area/getAreaByName',{
                            params:{
                              areaName: value,
                              areaId:this.parentNodeDate.parentId
                            }}).then(res =>{
                            if(res.code ==="0"){
                                callback()
                            }else if (res.code === 1){
                                callback(new Error("名称重复，重新输入！"))
                              window.alert("该关联区域已存在,添加失败!")
                            }
                        });
                    }
                }
        };
        const treeData = [];
        return {
            treeData : JSON.parse(JSON.stringify(treeData)),
            // defaultProps: {
            //     children: 'children',
            //     label: 'areaName'
            // },
            expandOnClickNode:"false",
            // search:'',
            show:false,

            judge:0,
            node:{},
            repeatName:'',//判断名字是否重复
            parentNodeDate:{},
            form:{
              // areaName: sessionStorage.getItem("createBy")
            },
            options:[],
            option:{},
            editform:{},
            dialogFormVisibleEdit:false,
            dialogFormVisible:false,
            currentPage:1,
            pageSize:10,
            total:'',
            small:"small",
            background:"background",
            prev:this.currentPage-1,
            pager:this.currentPage,
            next:this.currentPage+1,
            jumper:this.currentPage,
            tableData:[],
            casvalue: [],
            filterText: '',
            setKesLabel:{
              value:'areaId',
              label:'areaName',
              children:'children',
              multiple: true
            },
            rules: {
              areaName:[
                    {  required: true, min:1,max:50, message: '组织名不为空,长度：1 ~ 25 个字符', trigger: 'blur'},
                    {  validator: validateStruct_Name,required: true, message: '区域名重复或不规范，重新输入', trigger: 'blur'}
                ]
            },
          session: sessionStorage.getItem("createBy"),
        };
    },
    created(){
        this.load();
        console.log(sessionStorage.getItem("createBy"))
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    methods: {
        getStructByName(rule, value, callback){
                request.get('/area/getAreaByName',{
                    params:{
                      areaName: value,
                      areaId:this.parentNodeDate.areaId
                    }}).then(res =>{
                    if(res.code ==="0"){
                        callback()
                    }else {
                        callback(new Error("名称重复，重新输入！"))
                    }
                })
        },
        handleNodeClick(data) {
            this.parentNodeDate = data;
            sessionStorage.setItem("qyid", data.areaId)
            console.log(data)
            if (data.areaLevel === 2){
              this.show = true
              let Map = {
                "page":this.currentPage,
                "size":this.pageSize,
                "areaId":data.areaId,
              }
                request.post('/area/paging',Map).then(res =>{
                    console.log(res);
                    if (res.code === '0') {
                      this.tableData = res.data.structLists;
                      this.total = res.data.total
                    } else {
                      this.tableData = [];
                    }
                })
            }
            // if (data.areaLevel === 5) {
            //   this.show = true
            //   console.log(data)
            //   console.log(data.parentId)
            //   let Map = {
            //     "page":this.currentPage,
            //     "size":this.pageSize,
            //     "areaId":data.parentId,
            //   }
            //   request.post('/area/paging',Map).then(res =>{
            //     console.log(res);
            //     if (res.code === '0') {
            //       this.tableData = res.data.structLists;
            //       this.total = res.data.total
            //     } else {
            //       this.tableData = [];
            //     }
            //   })
            // }
            else if (data.areaLevel === 1 || data.areaLevel === 3 || data.areaLevel === 4 || data.areaLevel === 5) {
              this.show = false
            }
        },
      filterNode(value, data) {
        if (!value) return true;
        return data.areaName.indexOf(value) !== -1;
      },
        append(treeData){
          console.log(treeData)
          console.log(this.form.createBy)
            this.dialogFormVisible=true;

            this.form= {
              areaName:'',

            };

            if (treeData.areaId === 1) {
                this.form.parentId = 1;
                this.form.areaLevel = 2;
                this.form.createBy = sessionStorage.getItem("createBy")
            } else if(treeData.areaLevel === 1) {
                this.form.parentId = treeData.areaId;
                this.form.areaLevel = 2;
            } else if (treeData.areaLevel === 2) {
              this.form.parentId = treeData.areaId;
              this.form.areaLevel = 3;
            } else if (treeData.areaLevel === 3) {
              this.form.parentId = treeData.areaId;
              this.form.areaLevel = 4;
            } else if (treeData.areaLevel === 4) {
              this.form.parentId = treeData.areaId;
              this.form.areaLevel = 5;
            }
            // else {
            //     this.form.parentId = treeData.areaId;
            //     this.form.areaLevel = 1;
            // }
            // request.get('/Solution/getDept').then(res =>{
            //     this.option = res.data;
            //     // this.form.struct_type = this.option.dept_Name;
            // })
        },
      append2() {
        this.dialogFormVisible=true;
        this.form.parentId = -1;
        this.form.areaLevel = 1;
      },
        load() {
            request.get('/area/list').then(res =>{
                console.log(res.data.structList);
                this.treeData= res.data.structList;
              // for (let i = 0; i < res.data.structList.length; i++) {
              //   this.treeData[i].value= res.data.structList[i].areaName;
              //   this.treeData[i].label= res.data.structList[i].areaName;
              //   for (let j = 0; j <res.data.structList[i].children.length; j++) {
              //     this.treeData[i][j].value= res.data.structList[i].children[j].areaName;
              //     this.treeData[i][j].label= res.data.structList[i].children[j].areaName;
              //   }
              // }


            })
        },
        add() {
            // console.log(this.parentNodeDate.struct_id+"++++++++++");
            this.append(this.parentNodeDate);
        },
        remove(node, data) {
            // console.log( node.parent.data.struct_id + "---"+node.data.children + node.data.struct_id+data);
            // console.log(data.struct_id + "---"+data.children +data.struct_level);
            this.node = node;
            this.handleDelete(data.areaId,data.areaLevel);
        },
      handleDelete(id,areaLevel){
        // console.log(id+struct_level);
        console.log(id)
        console.log(areaLevel + "---" + this.parentNodeDate)
        request.delete("/area/delete/"+id).then(res =>{
          if(res.code ==="0"){
            this.$message({
              message:"删除成功！",
              type:"success"
            });
            console.log(id)
            if(areaLevel===3){
              this.handleNodeClick(this.parentNodeDate);
            }else {
              const parent = this.node.parent;
              const children = parent.data.children || parent.data ;
              const index = children.findIndex(d => d.id === id);
              console.log(parent+"==="+children+"==="+index);
              children.splice(index, 1);
            }
            this.load()
          }
          else if (res.code ==="1") {
            this.$message({
              message:"有子节点不能删除，删除失败！",
              type:"error"
            })
          } else if (res.code ==="2") {
            this.$message({
              message:"该区域被分配不能删除，删除失败！",
              type:"error"
            })
          }
        })
        this.load()
      },
        save(formName){
            console.log(formName);
            console.log(this.form);
            console.log(this.form.areaName);
            console.log(this.form.createBy);
            console.log(sessionStorage.getItem("createBy"))
          // this.form.areaName = sessionStorage.getItem("createBy")
          this.form.createBy = sessionStorage.getItem('userName')
            this.$refs[formName].validate((valid) => {
                // this.form.struct_type = '';
                if (valid) {
                    request.post('/area/save',this.form).then(res =>{
                        console.log(res.code+res.mag+JSON.stringify(res.data)+"save"+res);
                        if(res.code ==="0"){
                            this.$message({
                                message:"添加成功",
                                type:"success"
                            });
                          // this.handleNodeClick(this.form);
                          this.handleNodeClick(this.parentNodeDate)
                            if(this.parentNodeDate.areaLevel===1 && this.show ===true ){
                                // this.handleNodeClick(this.parentNodeDate);
                            }else {
                                if (!this.parentNodeDate.children) {
                                    this.parentNodeDate.children = []
                                }
                                this.parentNodeDate.children.push(res.data);
                            }
                            this.load()
                          this.dialogFormVisible = false;
                        }else {
                            this.$message({
                                message:"添加失败",
                                type:"error"
                            })
                        }
                        this.dialogFormVisible=false;
                    })
                  console.log(this.form)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            this.dialogFormVisible = false;
        },
        edit(formName){
            this.$refs[formName].validate((valid) => {
                //valid是检验的结果,bool值
              this.editform.updateBy = sessionStorage.getItem('userName')
                if (valid) {
                    request.post('/area/update',this.editform).then(res =>{
                        if(res.code ==="0"){
                            this.$message({
                                message:"编辑成功",
                                type:"success"
                            })
                          // this.show = true
                          // request.get('/area/paging',{
                          //   params:{
                          //     currentPage:this.currentPage,
                          //     pageSize:this.pageSize,
                          //     areaId:this.editform.parentId,
                          //     // areaId:JSON.stringify(data.areaId),
                          //     // search:this.search
                          //   }
                          // }).then(res =>{
                          //   console.log(res);
                          //   // this.tableData= res.data.structs;
                          //   this.tableData= res.data.structList;
                          //   this.total = res.data.total
                          // })
                          this.handleNodeClick(this.parentNodeDate)
                        }else {
                            this.$message({
                                message:"编辑失败",
                                type:"error"
                            })
                        }
                        this.dialogFormVisibleEdit=false;
                        // console.log(res+"edit"+res.code+res.mag+res.date);
                            this.node.data.areaName =this.editform.areaName;
                    })
                  this.handleNodeClick(this.parentNodeDate)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleEdit(row,data,node){
          console.log(row)
            this.dialogFormVisibleEdit=true;
            this.judge = data;
            this.node = node;
            // console.log(row+"----------"+JSON.stringify(row));
            // this.addNode = row;
            this.editform = JSON.parse(JSON.stringify(row));

            this.repeatName =row.areaName;
        },
      shanchu(row) {
        request.delete("/area/delete/"+row.areaId).then(res =>{
          if(res.code ==="0"){
            this.$message({
              message:"删除成功！",
              type:"success"
            });
            this.handleNodeClick(this.parentNodeDate);
            console.log()
            // if(row.areaLevel===3){
            //   // this.handleNodeClick(this.parentNodeDate);
            // }else {
            //   const parent = this.node.parent;
            //   const children = parent.data.children || parent.data ;
            //   const index = children.findIndex(d => d.id === row.areaId);
            //   console.log(parent+"==="+children+"==="+index);
            //   children.splice(index, 1);
            // }
            // this.load()
          } else if (res.code ==="1" || res.code ==="2") {
            this.$message({
              message:"该区域被分配不能删除，删除失败！",
              type:"error"
            })
          }
          // else {
          //   this.$message({
          //     message:"有子节点不能删除，删除失败！",
          //     type:"error"
          //   })
          // }
        })
        // this.load();
      },
        handleSizeChange(pageSize){
          console.log(sessionStorage.getItem("qyid"))
          var j = parseInt(sessionStorage.getItem("qyid"))
            this.pageSize = pageSize;
            this.load()
          // this.handleNodeClick(this.tableData)
          this.show = true
          let Map = {
            "page":this.currentPage,
            "size":this.pageSize,
            "areaId":j,
          }
          request.post('/area/paging',Map).then(res =>{
            console.log(res);
            if (res.code === '0') {
              this.tableData = res.data.structLists;
              this.total = res.data.total
            } else {
              this.tableData = [];
            }
          })
        },
        handleCurrentChange(pageNum){
          var s = parseInt(sessionStorage.getItem("qyid"))
            this.currentPage = pageNum;
            this.load()
          this.show = true
          let Map = {
            "page":this.currentPage,
            "size":this.pageSize,
            "areaId":s,
          }
          request.post('/area/paging',Map).then(res =>{
            console.log(res);
            if (res.code === '0') {
              this.tableData = res.data.structLists;
              this.total = res.data.total
            } else {
              this.tableData = [];
            }
          })
        }
    }
    };
</script>

<style>
    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }
    .custom-tree-node-areaName{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 14px;
      padding-right: 8px;
    }
</style>